import { isNotDefined } from '@sgme/fp';
import { Button, HStack } from '@sgme/ui';
import { useMemo } from 'react';

import { useUserContext } from '@/context/UserContext.tsx';

type Props = {
  clientId: number | undefined;
  onRemoveOverride: () => void;
};

export const TileOverridenClientIndicator = ({ clientId, onRemoveOverride }: Props) => {
  // 💡 Get current user and their clients from context
  const {
    currentUser: { clients },
  } = useUserContext();

  // 💡 Map client IDs to client names for quick lookup
  const clientNameById = useMemo(() => {
    // 💡 Reduce clients array to a dictionary { companyId: companyName }
    return clients.reduce(
      (acc, client) => {
        acc[client.companyId] = client.companyName;
        return acc;
      },
      {} as Record<number, string>,
    );
  }, [clients]);

  if (isNotDefined(clientId)) {
    return null;
  }
  return (
    <HStack className="mx-1 mb-2 p-2 fw-bold border border-warning">
      <span className="text-warning text-nowrap text-truncate" title={clientNameById[clientId]}>
        {clientNameById[clientId]}
      </span>
      <Button
        purpose="primary"
        color="warning"
        size="sm"
        onClick={onRemoveOverride}
        data-e2e="clear-account-button"
        iconPosition="icon-only"
      >
        <i className="icon icon-sm">close</i>
      </Button>
    </HStack>
  );
};
